import { isFeatureEnabled } from 'owa-feature-flags';

export default function isInClientStoreEnabled(): boolean {
    return isFeatureEnabled('addin-inClientStoreEnabled');
}
